import React from "react";

const ForgetPassword = () => (
  <div className="flex flex-col gap-4 text-center">
    <h2 className="text-lg font-semibold text-gray-900">
      Administrator recovery is temporarily unavailable
    </h2>
    <p className="text-sm text-gray-600">
      The legacy fixed-code recovery flow has been disabled. Contact an approved
      Super Admin through the documented support process for a reviewed account
      recovery.
    </p>
  </div>
);

export default ForgetPassword;
